import { appSetCreditBalance, appSetLoading, setPaymentData } from "store/actions/appAction";
import { setTableData } from "store/actions/dataTableAction";

import axios from "../axios/axios";
import { errorDispatcher } from "helpers";

export const apiIncreaseCredit = (params, token) => (dispatch, getState) => {
  axios
    .post(
      "subscriptions/businessCharge",
      { price: params },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((response) => {
      window.location.href = response.data.payment.url;
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiSubscriptionBusinessCharge = (authority, token) => (dispatch, getState) => {
  const form = {
    authority,
  };
  axios
    .post("subscriptions/paybackCharge", form, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setPaymentData({ ...form, message: response.data.message }));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiVitsellCharge = (authority, token) => (dispatch, getState) => {
  const form = {
    authority,
  };
  axios
    .post("vitsell/verify", form, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      dispatch(setPaymentData({ ...form, message: response.data.message }));
    })
    .catch((error) => {
      errorDispatcher(error, dispatch);
    });
};

export const apiGetChargeHistory =
  ({ pagination, token, transferType, sort, search }) =>
  (dispatch, getState) => {
    let params = {};

    if (sort) {
      params.key = sort.key;
      params.dir = sort.dir;
    }

    if (search) {
      params.mainColumn = search.mainColumn;
      params.searchText = search.searchText;
      params.subColumn = search.subColumn;
      params.altSearchText = search.altSearchText;
      params.type = search.type;
    }

    dispatch(appSetLoading());
    axios
      .get(`subscriptions/chargeHistory?limit=${pagination.limit}&page=${pagination.page}`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((response) => {
        dispatch(setTableData(response.data.payments, response.data.paginate));
        // dispatch(setTransfers(response.data?.payments));
        dispatch(appSetCreditBalance(response.data?.balance));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };

export const apiGetSmsHistory =
  ({ pagination, token, sort, search }) =>
  (dispatch) => {
    let params = { ...pagination, ...sort, ...search };

    dispatch(appSetLoading());
    axios
      .get(`smsHistories`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((response) => {
        dispatch(setTableData(response.data.smsHistories, response.data.paginate));
        dispatch(appSetLoading(false));
      })
      .catch((error) => {
        errorDispatcher(error, dispatch);
      });
  };
